import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import axios from "axios";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "fr", "es", "sw"],
    fallbackLng: "en",
    ns: ["common", "auth", "profile", "home", "dashboard", "map"],
    defaultNS: "common",
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`
    },
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: "kin_ui_lang",
      cacheUserLanguage: true
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: true
    }
  });

// Keep axios Accept-Language header in sync with active language
i18n.on("languageChanged", (lng) => {
  axios.defaults.headers.common["Accept-Language"] = lng;
  document.documentElement.lang = lng;
});

// Set on first load
axios.defaults.headers.common["Accept-Language"] = i18n.language;

export default i18n;
